import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('bringozTimeConvert', bringozTimeConvert);

function bringozTimeConvert($translate) {

  return function bringozTimeConvertFilter(timeInSeconds, isMillis, isMinutes) {

    if (!timeInSeconds) {
      return '---';
    }

    if (isMillis) {
      timeInSeconds = (timeInSeconds / 1000);
    }

    if (isMinutes) {
      timeInSeconds = (timeInSeconds * 60);
    }

    const minute = 60;
    const hour = minute * 60;
    const minutesValue = Math.floor((timeInSeconds / hour) % 1 * minute);

    const minutesText = $translate.instant(minutesValue > 1 ? 'mins' : 'min');
    const hoursText = $translate.instant((timeInSeconds / hour) >= 2 ? 'hrs' : 'hr');

    return timeInSeconds >= hour ?
      Math.floor(timeInSeconds / hour) + ' ' + hoursText + ' ' + (minutesValue ? (minutesValue + ' ' + minutesText) : '') :
      Math.floor(timeInSeconds / minute) + ' ' + minutesText;
  }
}
